import * as yup from 'yup';

const fioPattern = /^[A-Za-zА-Яа-яЁё\s-]+$/;
const fullBirthDatePattern = /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.(19|20)\d{2}$/;
export const fullPhonePattern = /^\+7 \([3-9]\d{2}\) \d{3}-\d{2}-\d{2}$/;

const isPastDate = value => {
  if (!value) return false;

  const [day, month, year] = value.split('.').map(Number);
  const date = new Date(year, month - 1, day);

  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return false; // несуществующая дата
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return date < today; // строго в прошлом
};

export const formatBirthDate = value => {
  // оставляем только цифры
  const digits = value.replace(/\D/g, '').slice(0, 8);

  if (!digits) return '';

  let result = digits.slice(0, 2);

  // добавляем разделитель
  if (digits.length >= 2) result += '.' + digits.slice(2, 4);
  if (digits.length >= 4) result += '.' + digits.slice(4);

  return result;
};

export const schema = yup.object({
  price: yup.string(),
  firstPaymentPercent: yup.string(),
  firstPaymentAmount: yup.string(),
  fio: yup.string().trim().required('Введите ФИО').matches(fioPattern, 'ФИО может содержать только буквы'),
  phone: yup.string().required('Обязательное поле').matches(fullPhonePattern, 'Введите корректный номер'),
  email: yup.string().email('Неверный email'),
  birthDate: yup
    .string()
    .required('Введите дату в формате ДД.ММ.ГГГГ')
    .matches(fullBirthDatePattern, 'Введите дату в формате ДД.ММ.ГГГГ')
    .test('past-date', 'Некорректная дата рождения', isPastDate),
  mortgageType: yup.string(),
  isCitizen: yup.boolean(),
  isMarried: yup.boolean(),
  hasApprovedMortgage: yup.boolean(),
  bankName: yup.string(),
  mortgageSum: yup.string(),
  checkbox_ads: yup.string().oneOf(['true', 'false']).notRequired(),
});
